module.exports = __webpack_public_path__ + "static/media/ref.23b76fa0.png";